<div mat-dialog-title>Usuwanie opłaty</div>

<p>
  Czy na pewno chcesz usunąć opłatę od <b>{{ liability.billerName }}</b> o tytule <b>{{ liability.title }}</b
  >?
</p>

<mat-dialog-actions align="start">
  <button mat-raised-button color="accent" [matDialogClose]="true" cdkFocusInitial>Usuń</button>
  <button mat-button matDialogClose>Anuluj</button>
</mat-dialog-actions>
